import { render, staticRenderFns } from "./SortableTableHeader.vue?vue&type=template&id=441e0cd8&scoped=true"
import script from "./SortableTableHeader.vue?vue&type=script&lang=ts"
export * from "./SortableTableHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441e0cd8",
  null
  
)

export default component.exports